import React from 'react'

export default function VerifyEmail() {
  return (
    <div>Verify Email</div>
  )
}
